module.exports = __webpack_public_path__ + "static/media/Info.840355e6.svg";